export const updateDocument = (payload?: any) => ({
    type: "@saga/UPDATE_DOCUMENT",
    payload
});

